import React, { Suspense, lazy, useEffect } from "react";
import {
  BrowserRouter,
  HashRouter,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import ProtectedRoute from "./protectedRoute";
import Welcome from "../components/welcomescreen/Welcome";
import ReactGA from "react-ga4";
import ConflictEmail from "../screen/conflictemails/ConflictEmail.js";

const LandingPage = lazy(() => import("../screen/home/Home"));
const LoginOption = lazy(() => import("../screen/auth/LoginOption"));
const Login = lazy(() => import("../screen/auth/Login"));
const Forgot = lazy(() => import("../screen/auth/Forgot"));
const Register = lazy(() => import("../screen/auth/Register"));
const Verification = lazy(() => import("../screen/auth/Verify"));
const AcademyForm = lazy(() => import("../screen/auth/AcademyForm.jsx"));
const AcademyPurchase = lazy(() =>
  import("../screen/subscription/AcademyPurchase.jsx")
);

// After Login Screens
const Notification = lazy(() => import("../screen/notification/Notification"));
const Faq = lazy(() => import("../screen/FAQ/Faq"));
const About = lazy(() => import("../screen/about/About"));
const Terms = lazy(() => import("../screen/terms/Terms"));
const Question = lazy(() => import("../screen/question/Question"));
const Podcast = lazy(() => import("../screen/podcast/Podcast"));
const PodcastList = lazy(() => import("../screen/podcast/PodcastList.jsx"));
const PodcastDetails = lazy(() =>
  import("../screen/podcast/PodcastDetails.jsx")
);
const Community = lazy(() => import("../screen/community/Community"));

// Journal Section
const Journal = lazy(() => import("../screen/journal/Journal"));
const Addclass = lazy(() => import("../screen/journal/AddClasses"));

// Blog Section
const Blog = lazy(() => import("../screen/blogs/Blogs"));
const BlogDetail = lazy(() => import("../screen/blogs/BlogDetail"));

// Dashboard Section
const Dashboard = lazy(() => import("../screen/dashboard/Dashboard"));
const ExcerciseDetails = lazy(() =>
  import("../screen/dashboard/ExcerciseDetails.jsx")
);
const ProgramSession = lazy(() =>
  import("../screen/dashboard/ProgramSession.jsx")
);
const WorkoutDetails = lazy(() =>
  import("../screen/dashboard/WorkoutSession.jsx")
);
const ProgramView = lazy(() => import("../screen/dashboard/ProgramOverview"));
const Workout = lazy(() => import("../screen/dashboard/Workout"));
const GettingStarted = lazy(() => import("../screen/dashboard/GettingStarted"));
const ExcerciseSession = lazy(() =>
  import("../screen/dashboard/ExcerciseSession")
);

// Profile Section
const Profile = lazy(() => import("../screen/profile/Profile"));
const ChangePassword = lazy(() => import("../screen/profile/ChangePassword"));

// Contact Section
const ContactUs = lazy(() => import("../screen/contact/ContactUs"));
const Feedback = lazy(() => import("../screen/contact/Feedback"));

// Subscription Section
const Subscription = lazy(() => import("../screen/subscription/Subscription"));
const Pricing = lazy(() => import("../screen/subscription/Pricing.jsx"));
const AcademyInnerPurchase = lazy(() =>
  import("../screen/subscription/AcadenyInnerPurchase.jsx")
);
const AcademyInnerPurchaseTest = lazy(() =>
  import("../screen/subscription/AcademyInnerPurchaseTest.jsx")
);
const AcademySubscription = lazy(() =>
  import("../screen/subscription/AcademySubscription")
);
const StudentSubscription = lazy(() =>
  import("../screen/subscription/StudentSubscription")
);
// const AddStudent = lazy(() => import('../screen/subscription/AddStudent'));
const LoginSubscription = lazy(() =>
  import("../screen/subscription/LoginSubscription")
);

// shop Section
const Products = lazy(() => import("../screen/shop/Products"));
const ProductDetails = lazy(() => import("../screen/shop/ProductDetails"));
const ShoppingCart = lazy(() => import("../screen/shop/ShoppingCart"));
const MyOrders = lazy(() => import("../screen/shop/MyOrders"));
const Reorder = lazy(() => import("../screen/shop/Reorder"));
const Viewinvoice = lazy(() => import("../screen/shop/Viewinvoice"));
const LogOffCart = lazy(() => import("../screen/shop/LogOffCart"));
const LogOffCheckout = lazy(() => import("../screen/shop/LogOffCheckout"));
const PlaceOrderBeforeLog = lazy(() =>
  import("../screen/shop/PlaceOrderBeforeLog")
);

const Routing = () => {
  const userData = useSelector(
    (state) => state?.profileReducer?.user_data?._id
  );
  const userId = `6729d2d325fb61b209feb81c`;

  ReactGA.initialize([
    {
      trackingId: "G-J5N26Q1QGQ",
    },
  ]);

  useEffect(() => {
    ReactGA.send(window.location.pathname + window.location.search);
  }, []);

  return (
    <>
      <BrowserRouter>
        <Suspense fallback={<Welcome />}>
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route path="/community" element={<Community />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/addclass" element={<Addclass />} />
              {/* <Route path='/shoppingcart' element={<ShoppingCart />} /> */}
              <Route path="/question" element={<Question />} />
              <Route path="/questionpage" element={<Question />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/program-session" element={<ProgramSession />} />
              <Route path="/workout-session" element={<WorkoutDetails />} />
              <Route path="/programview" element={<ProgramView />} />
              <Route path="/workoutprogram" element={<Workout />} />
              <Route path="/excercise" element={<ExcerciseSession />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/changepassword" element={<ChangePassword />} />
              <Route path="/notification" element={<Notification />} />
              <Route path="/myorder" element={<MyOrders />} />
              <Route path="/reorder" element={<Reorder />} />
              <Route
                path="/studentsubscription"
                element={<StudentSubscription />}
              />
              {/* <Route path='/addstudent' element={<AddStudent />} /> */}
              <Route path="/viewinvoice" element={<Viewinvoice />} />
              <Route path="/academy" element={<AcademyInnerPurchaseTest />} />
              <Route path="/pricing" element={<Pricing />} />
            </Route>

            <Route path="/excercise-details" element={<ExcerciseDetails />} />
            <Route path="/shoppingcart" element={<ShoppingCart />} />
            <Route path="/products" element={<Products />} />
            <Route path="/cart" element={<LogOffCart />} />
            <Route path="/checkout" element={<LogOffCheckout />} />
            <Route
              path="/placeordersummary"
              element={<PlaceOrderBeforeLog />}
            />
            <Route path="/productdetails" element={<ProductDetails />} />
            <Route path="/getstarted" element={<GettingStarted />} />
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/podcast-list" element={<PodcastList />} />
            <Route
              path="/podcast-detail/:id/:name"
              element={<PodcastDetails />}
            />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blogdetail" element={<BlogDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/terms" element={<Terms />} />

            {/* <Route path='/academySubscription2' element={<AcademySubscription2 />} /> */}
            <Route path="/subscripition" element={<LoginSubscription />} />
            <Route path="/academysubscribe" element={<AcademyForm />} />
            <Route path="/feedback" element={<Feedback />} />

            <Route path="/" element={<LandingPage />} />
            <Route path="/loginoption" element={<LoginOption />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot" element={<Forgot />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verification" element={<Verification />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/academy-purchase" element={<AcademyPurchase />} />
            <Route
              path={`/conflicted_emails/:id`}
              element={<ConflictEmail />}
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
};

export default Routing;
